export default __webpack_public_path__ + "static/home-jack-226c1b2cabbd863ff9e2d1b7f91e4bae.png";